import { useEffect, useState } from "react";
import { brandConfiguration } from "@/brands/config";
import { useBrowserAPI } from "./useBrowserAPI";
const lastSearchesStorage = (storageItem, denyPattern) => {
    try {
        const lastSearch = JSON.parse(storageItem)
            .sort((a, b) => {
            return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
        })
            .shift();
        return denyPattern && (lastSearch === null || lastSearch === void 0 ? void 0 : lastSearch.link.includes(denyPattern))
            ? false
            : lastSearch;
    }
    catch (error) {
        console.error("Error while parsing last searches from local storage:", error);
        return undefined;
    }
};
const capitalizeFirstLetter = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
export const useLastSearch = () => {
    const { brand, lastSearchDenyPattern } = brandConfiguration;
    const brandName = capitalizeFirstLetter(brand);
    const [lastSearches, setLastSearches] = useState(undefined);
    const { bLocalStorage } = useBrowserAPI();
    useEffect(() => {
        const storageItem = bLocalStorage === null || bLocalStorage === void 0 ? void 0 : bLocalStorage.getItem(`last${brandName}Searches`);
        if (typeof storageItem === "string") {
            setLastSearches(lastSearchesStorage(storageItem, lastSearchDenyPattern));
        }
        else {
            setLastSearches(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brandName, lastSearchDenyPattern]);
    return lastSearches;
};
